/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import { useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../AbstractElements";
import { Apps, ToDoHeading } from "../../Constant";
import { useAppDispatch } from "../../Redux-Toolkit/Hooks";
import { setTodoList } from "../../Redux-Toolkit/Reducers/ToDoSlice";
import { TodoApi } from "../../api";
import Leftsideuser from "./Leftsideuser/Leftsideuser";
import ToDoApp from "./ToDoApp";

const ToDoContainer = () => {
  const dispatch = useAppDispatch();

  const fetchTodo = async () => {
    try {
      await axios.get(`${TodoApi}`).then((resp) => {
        dispatch(setTodoList(resp.data));
      });
    } catch (error) {
      toast.error("error"+ error);
    }
  };

  useEffect(() => {
    fetchTodo();
  }, []);

  return (
    <>
      <Breadcrumbs pageTitle={ToDoHeading} parent={Apps} title={ToDoHeading} />
      <Container fluid className="email-wrap bookmark-wrap todo-wrap">
        <Row>
          <Leftsideuser />
          <ToDoApp />
        </Row>
      </Container>
      <ToastContainer />
    </>
  );
};

export default ToDoContainer;
